"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoHeaderNavContent = void 0;

var _react = _interopRequireDefault(require("react"));

var _hooks = require("material-ui-popup-state/hooks");

var _core = require("@material-ui/core");

var _NavCallout = require("./items/NavCallout");

var _FaNavItems = require("./items/FaNavItems");

var _NavCtaCallout = require("./items/NavCtaCallout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var NoHeaderNavContent = function NoHeaderNavContent(_ref) {
  var links = _ref.links,
      calloutIcon = _ref.calloutIcon,
      calloutTitle = _ref.calloutTitle,
      calloutContent = _ref.calloutContent,
      close = _ref.close,
      _ref$calloutCtas = _ref.calloutCtas,
      calloutCtas = _ref$calloutCtas === void 0 ? [] : _ref$calloutCtas,
      children = _ref.children;

  var childrenWithClose = _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      close: close
    });
  });

  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 12,
    spacing: 1,
    direction: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_FaNavItems.FaNavItems, {
    items: links,
    noHeaderWidth: 3,
    close: close
  })), calloutContent ? /*#__PURE__*/_react.default.createElement(_NavCallout.NavCallout, {
    calloutIcon: calloutIcon,
    calloutTitle: calloutTitle,
    calloutContent: calloutContent
  }) : calloutCtas.length ? /*#__PURE__*/_react.default.createElement(_NavCtaCallout.NavCtaCallout, {
    calloutCtas: calloutCtas
  }, childrenWithClose) : /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: '1rem'
    }
  }));
};

exports.NoHeaderNavContent = NoHeaderNavContent;